export default function SupplierPerformanceEvaluation() {

  return (
      <p>نظارت بر عملکرد تأمین کننده</p>
  );
};